export enum IconTokenType {
  Large = 'icon-size-large',
  Standard = 'icon-size-standard',
  Medium = 'icon-size-medium',
  Small = 'icon-size-small',
  XSmall = 'icon-size-xsmall',
}
